export function isDragHandle(target: EventTarget | null): boolean {
  const node = target as HTMLElement | null;
  if (!node) return false;
  return Boolean(node.closest('.drag-handler'));
}

